import { defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "sliderCard",
  type: "object",
  title: "Slider Card",
  fields: [
    {
      name: "image",
      title: "Image",
      type: "imageWithAlt",
      options: { hotspot: true },
      validation: (Rule) => Rule.required()
    },
    {
      name: "title",
      type: "multilingualArrayString",
      validation: (Rule) => Rule.required()
    },
    {
      name: "description",
      type: "multilingualArrayText",
      validation: (Rule) => Rule.required()
    },
    {
      type: "ctaButtons",
      name: "ctaButtons",
      title: "CTA Buttons",
      validation: (Rule) => Rule.max(1),
      options: {
        collapsible: true,
        collapsed: true
      }
    }
  ],
  preview: {
    select: {
      title: "title",
      media: "image"
    },
    prepare({ title, media }) {
      return {
        title: multilingualStringPreview(title),
        media
      };
    }
  }
});
